import { Box, Grid, GridItem, Input } from "@chakra-ui/react";
import { Banner, FormRow, Select } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { observer } from "mobx-react-lite";
import type { PositionMappingStore } from "./position-mapping-store";

type PositionMappingSectionProps = {
  readonly store: PositionMappingStore;
};

export const PositionMappingSection = observer(function PositionMappingSection({
  store,
}: PositionMappingSectionProps) {
  if (!store.hasUnmatchedPositions) return null;

  return (
    <Box ref={store.wrapperRef} id="position-mapping-section">
      <Banner
        status="warning"
        variant="standalone"
        title={t`Position mapping required`}
        description={
          store.hasTimeTrackingEntries
            ? t`Some positions are not available in the target project. Map them below. Time tracking entries will also be updated.`
            : t`Some positions are not available in the target project. Map them below.`
        }
      />
      <FormRow
        mt="4"
        title={t`Map positions`}
        style={{ alignItems: "start" }}
        titleClassName="mt-4"
      >
        <Box>
          <Grid
            alignItems="center"
            columnGap="1rem"
            templateColumns="1fr auto 1fr"
            color="gray.500"
            fontSize="xs"
          >
            <GridItem>
              <Trans>Current position</Trans>
            </GridItem>
            <GridItem w="4"></GridItem>
            <GridItem>
              <Trans>New position</Trans>
            </GridItem>
          </Grid>
          {store.unmatchedWorkTypes.map((workType) => (
            <Grid
              key={workType.id}
              alignItems="center"
              columnGap="1rem"
              templateColumns="1fr auto 1fr"
            >
              <GridItem>
                <Input readOnly value={workType.title} />
              </GridItem>
              <GridItem>
                <Icon name="arrow-narrow-right" w="4" h="4" color="grey.400" />
              </GridItem>
              <GridItem>
                <Select
                  asPortal
                  value={store.positionMapping.get(workType.id) ?? ""}
                  onChange={(value) =>
                    store.setMapping(workType.id, value as string)
                  }
                  options={store.targetWorkTypeOptions}
                  placeholder={t`Select position`}
                />
              </GridItem>
            </Grid>
          ))}
        </Box>
      </FormRow>
    </Box>
  );
});
